module.exports = __webpack_public_path__ + "static/media/codec.dfe9395d.wav";